export default [
  {
    field: 'ssn',
    method: 'isEmpty',
    validWhen: false,
    message: 'Last 4 digits of your SSN are required',
  },
  {
    field: 'ssn',
    method: 'isLength',
    validWhen: true,
    message: 'Last 4 digits of your SSN are required',
    options: [{ min: 4, max: 4 }],
  },
  {
    field: 'ssn',
    method: 'isInt',
    validWhen: true,
    message: 'Last 4 digits of your SSN should be numeric',
  },
  {
    field: 'birthday',
    method: 'isEmpty',
    validWhen: false,
    message: 'Your birthday is required',
  },
  {
    field: 'birthday',
    method: 'isDate',
    options: [{
      strictMode: true,
      format: 'YYYY-MM-DD',
      delimiters: ['-'],
    }],
    validWhen: true,
    message: 'Date should be in the format YYYY-MM-DD',
  },
];
